<div class="w-full border border-gray-300 rounded-lg relative overflow-hidden" [style.height]="mapHeight">
  <!-- Map container -->
  <div
    #mapContainer
    class="w-full h-full"
    [class.hidden]="shouldShowNoDataMessage()">
  </div>
  
  <!-- No data message overlay -->
  <app-no-data-message
    *ngIf="shouldShowNoDataMessage()"
    [icon]="'pi-exclamation-triangle'"
    [iconColor]="'text-yellow-500'"
    [title]="'scope3.transport.chart.noData'"
    [description]="'scope3.transport.chart.noDataDescription'"
    [showBackground]="false"
    [containerClasses]="'absolute inset-0 text-gray-600'">
  </app-no-data-message>
</div>
